import React, { Component } from "react";

class Contact extends Component {
  render() {

    return (
      <section id="contact" >

        <div className="row">  

              <div className="footer-col">
                <p className="address">
                  <a href="/terms">Terms and Conditions</a>
                  <br />
                  <a href="/closed">Closure</a>
                </p>
              </div>
        </div>
      </section>
    );
  }
}

export default Contact;
